// extracted by mini-css-extract-plugin
export default {"header":"MobileHeader_header__VFe3s","container":"MobileHeader_container__T-eF0"};